import React from 'react'
import { useTranslation } from 'react-i18next'
import { Box, EmptyState } from '@node-space/ui-components'
import { Lottie } from 'components/Animations/ThemeLottie'
import { useWalletContext } from 'hooks/context'

export const NoTransactions = () => {
  const { t } = useTranslation()
  const wallet = useWalletContext()
  return (
    <Box padding={16}>
      <EmptyState
        testId="empty-state"
        LottiePlayer={<Lottie src="no-data" />}
        title={t('wallets.emptyStateHeadline')}
        description={t('wallets.emptyStateDescription', { walletName: wallet?.description })}
      />
    </Box>
  )
}
